<p>BasePopupComponent is not meant to be used directly. Instead, extend it from a different component.</p>
